export const setUser = (user) => ({
  type: 'SET_USER',
  user: user,
});
